import { render, staticRenderFns } from "./OnePage.vue?vue&type=template&id=a09067bc&scoped=true&"
import script from "./OnePage.vue?vue&type=script&lang=js&"
export * from "./OnePage.vue?vue&type=script&lang=js&"
import style0 from "./OnePage.vue?vue&type=style&index=0&id=a09067bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09067bc",
  null
  
)

export default component.exports